export const copy = {
  modal: {
    header: "Are you sure you want to end this chat?",
    body: "By submitting a ticket, you will be ending this live chat. You cannot undo this action.",
    actions: {
      confirm: "Confirm",
      close: "Close",
    },
  },
};
